export const TOUR_WEEKDAYS = [
    { value: 1, short: "Mo", label: "Montag" },
    { value: 2, short: "Di", label: "Dienstag" },
    { value: 3, short: "Mi", label: "Mittwoch" },
    { value: 4, short: "Do", label: "Donnerstag" },
    { value: 5, short: "Fr", label: "Freitag" },
] as const

export type TourWeekday = (typeof TOUR_WEEKDAYS)[number]["value"]

/** Platzhalter-Status für die Dispo-Vorschau, bis Einsätze vom Backend kommen. */
export type TourStopPreviewStatus = "open" | "done" | "problem" | "notVisited"

/** Platzhalter Typen, bis Einsätze vom Backend kommen. */

export type TourObjectRef = {
    _id: string
    objectIndication: string
    name?: string
    adress: {
        street: string
        nr: string
        plz: string
        city: string
    }
}

export type TourEmployeeRef = {
    _id: string
    first_name: string
    last_name: string
}

export type TourAdHocTask = {
    _id: string
    activity: string
    kind: "openTask" | "newTask"
}

export type TourStop = {
    _id: string
    object: TourObjectRef
    weekday: TourWeekday
    sortOrder: number
    isAdHoc?: boolean
    adHocTask?: TourAdHocTask
    previewStatus: TourStopPreviewStatus
}

export type Tour = {
    _id: string
    name: string
    active: boolean
    employee?: TourEmployeeRef
    stops: TourStop[]
}

export const PREVIEW_STATUS_LABEL: Record<TourStopPreviewStatus, string> = {
    open: "Offen",
    done: "Erledigt",
    problem: "Problem",
    notVisited: "Nicht angefahren",
}

export const PREVIEW_STATUS_COLOR: Record<TourStopPreviewStatus, string> = {
    open: "gold",
    done: "green",
    problem: "red-inverse",
    notVisited: "default",
}
